import { BirthdateFieldsForm } from "@/forms/customer/BirthdateFields";

export const validateBirthdayDay = (
  value: string,
  formValues: BirthdateFieldsForm,
) => {
  const day = parseInt(value);
  if (isNaN(day)) {
    return "Datofelt kan kun inneholde tall";
  }
  if (!(day >= 1 && day <= 31)) {
    return "Datofelt kan kun inneholde tall mellom 1 og 31";
  }
  if (
    !isOlderThanEighteen(value, formValues.birth.month, formValues.birth.year)
  ) {
    return "Du må være over 18 år for å handle i nettbutikken";
  }
};

export const validateBirthdayMonth = (
  value: string,
  formValues: BirthdateFieldsForm,
) => {
  const month = parseInt(value);
  if (isNaN(month)) {
    return "Månedsfelt kan kun inneholde tall";
  }
  if (!(month >= 1 && month <= 12)) {
    return "Månedsfelt kan kun inneholde tall mellom 1 og 12";
  }
  if (
    !isOlderThanEighteen(formValues.birth.day, value, formValues.birth.year)
  ) {
    return "Du må være over 18 år for å handle i nettbutikken";
  }
};

export const validateBirthdayYear = (
  value: string,
  formValues: BirthdateFieldsForm,
) => {
  if (!/^\d+$/.test(value)) {
    return "Årfeltet kan kun inneholde tall";
  }
  if (value.length !== 4) {
    return "Skriv inn årstallet med fire siffer, f.eks. 2024";
  }
  const currentYear = new Date().getUTCFullYear();
  const year = parseInt(value);
  if (!(year >= 1900 && year <= currentYear)) {
    return `Årstallet må være mellom 1900 og ${currentYear}`;
  }
  if (
    !isOlderThanEighteen(formValues.birth.day, formValues.birth.month, value)
  ) {
    return "Du må være over 18 år for å handle i nettbutikken";
  }
};

function isOlderThanEighteen(
  day: string,
  month: string,
  year: string,
): boolean {
  // This is required on Safari
  const paddedDay = day.padStart(2, "0");
  const paddedMonth = month.padStart(2, "0");

  const birthDate = new Date(year + "-" + paddedMonth + "-" + paddedDay);

  const today = new Date();
  let age = today.getUTCFullYear() - birthDate.getUTCFullYear();
  const monthDiff = today.getUTCMonth() - birthDate.getUTCMonth();
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getUTCDate() < birthDate.getUTCDate())
  ) {
    age--;
  }
  return age >= 18;
}
